/* eslint-disable */
/**
 * 获取url
 */
export function getPageUrl({ page = '', params = {}, route = '' } = {}) {
  const { origin } = location
  const paramString = Object.keys(params)
    .map(key => {
      return `${key}=${encodeURI(params[key])}`
    })
    .join('&')
  if (location.href.indexOf('ylyk.com/test/') > 0) {
    return `${origin}/test/ylsn/${page}?${paramString}#${route}`
  }
  if (location.href.indexOf('ylyk.com/pre/') > 0) {
    return `${origin}/pre/ylsn/${page}?${paramString}#${route}`
  }
  if (location.href.indexOf('ylyk.com/dev/') > 0) {
    return `${origin}/dev/ylsn/${page}?${paramString}#${route}`
  }
  if (location.href.indexOf('//localhost') > 0) {
    return `${origin}/${page}?${paramString}#${route}`
  }
  return `${origin}/ylsn/${page}?${paramString}#${route}`
}
